import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const LoginForm = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [show, setShow] = useState(false);
    const [result, setResult] = useState("");
    const navigate = useNavigate();

    const handleClose = () => setShow(false);

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            const result = await api.post("/v1/user/login", {
                email: username,
                password: password,
                origin: "android"
            });

            if (result.data.role === "user") {
                setResult("Yetkiniz yok.");
                setShow("danger");
                return;
            }
            setResult("Giriş başarılı, yönlendiriliyorsunuz.");
            setShow("success");
            localStorage.setItem("JWTTOKEN", result.data.token);
            setTimeout(() => navigate("/"), 1000);


        } catch (err) {
            setResult(err.response?.data?.message || "Giriş başarısız.");
            setShow("danger");
        }
    };

    return (
        <>
            {/* HATA VEYA BAŞARI MESAJI */}
            {show && (
                <Alert variant={show === "success" ? "success" : "danger"} onClose={handleClose} dismissible>
                    <Alert.Heading>{show === "success" ? "Başarılı" : "Hata"}</Alert.Heading>
                    <p className="mb-0">{result}</p>
                </Alert>
            )}

            {/* GİRİŞ KARTI */}
            <Card style={styles.card}>
                <Card.Body className="p-4 p-md-5">
                    <Card.Title className="text-center mb-4 fw-bold fs-3">Giriş Yap</Card.Title>

                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicEmail" className="mb-3">
                            <Form.Label style={styles.label}>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="ornek@email.com"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                style={styles.input}
                                className="shadow-none"
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword" className="mb-4">
                            <Form.Label style={styles.label}>Şifre</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Şifreniz"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                style={styles.input}
                                className="shadow-none"
                            />
                        </Form.Group>

                        <Button type="submit" className="w-100 py-2" style={styles.button}>
                            Giriş Yap
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </>
    );
};

const styles = {
    card: {
        backgroundColor: '#1E1E1E',
        borderColor: '#2A2A2A',
        color: '#FFFFFF',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.5)'
    },
    label: {
        color: '#e4e4e7',
        fontSize: '14px',
        fontWeight: '500',
        marginBottom: '8px'
    },
    input: {
        backgroundColor: '#2A2A2A',
        color: '#FFFFFF',
        borderColor: '#3f3f46',
        padding: '12px 15px',
        borderRadius: '8px',
    },
    button: {
        backgroundColor: '#029220',
        borderColor: '#029220',
        fontWeight: '600',
        borderRadius: '8px',
        fontSize: '16px',
        marginTop: '10px'
    }
};

export default LoginForm;